var _path, _path2, _path3, _path4, _path5, _path6, _path7;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 98,
    height: 25,
    viewBox: "0 0 98 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35 5C35 2.23858 37.2386 0 40 0C42.7614 0 45 2.23858 45 5V20C45 22.7614 42.7614 25 40 25C37.2386 25 35 22.7614 35 20V5Z",
    fill: "#DD55FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M35 20C35 17.2386 37.2386 15 40 15H55C57.7614 15 60 17.2386 60 20C60 22.7614 57.7614 25 55 25H40C37.2386 25 35 22.7614 35 20Z",
    fill: "#DD55FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M80.4162 2.69999C81.9584 0.0466188 85.7907 0.04662 87.3329 2.69999L96.7278 18.8647C98.2776 21.5313 96.3538 24.8747 93.2695 24.8747H74.4796C71.3953 24.8747 69.4715 21.5313 71.0213 18.8647L80.4162 2.69999Z",
    fill: "#FFB800"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.06359 17.0281C9.16833 17.3227 10.4098 16.9781 10.971 16.3865C11.4488 15.8826 11.7912 14.8424 11.0562 14.1073C10.4271 13.4782 9.34453 13.6666 8.80627 14.3394C8.47155 14.7578 8.44589 15.1927 8.41896 15.6493C8.39311 16.0875 8.36609 16.5456 8.06359 17.0281Z",
    fill: "#00BACE"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M11.7167 12.4182C11.4213 12.8036 11.1848 13.1255 11.0339 13.3341C11.3807 13.5176 11.6613 13.8094 11.8426 14.1351C12.0439 13.9785 12.3544 13.7334 12.7261 13.4277L11.7167 12.4182Z",
    fill: "#00BACE"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M13.2004 13.0319C14.1839 12.1993 17.0647 9.67648 17.1338 8.38441C17.1516 8.05085 16.9224 7.83279 16.5768 7.86919C15.2815 8.0054 12.9066 10.9042 12.0974 11.9288L13.2004 13.0319Z",
    fill: "#00BACE"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.5 25C19.4036 25 25 19.4036 25 12.5C25 5.59644 19.4036 0 12.5 0C5.59644 0 0 5.59644 0 12.5C0 19.4036 5.59644 25 12.5 25ZM14.568 8.33314C15.3477 7.66483 15.9838 7.31291 16.5124 7.2573C17.2347 7.18138 17.7862 7.70677 17.7481 8.4173C17.7199 8.94472 17.394 9.59267 16.7518 10.3982C15.592 11.8528 13.5439 13.606 12.0615 14.7435C12.2001 15.4863 11.9243 16.2754 11.4174 16.8099C10.5879 17.6845 8.81975 18.0535 7.43653 17.4614C7.23969 17.3771 7.18717 17.1221 7.3344 16.9668C7.7523 16.5262 7.78033 16.0591 7.81003 15.564C7.84042 15.0574 7.87256 14.5216 8.32587 13.955C8.81421 13.3446 9.63899 13.0099 10.4215 13.132C11.4933 11.6299 13.1573 9.54224 14.568 8.33314Z",
    fill: "#00BACE"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.3be3264d7bd2abc2d20ec1b1d92ab16c.svg";
export { ForwardRef as ReactComponent };